import axios from 'axios'
import { SERVER_API } from 'config'

axios.defaults.baseURL = SERVER_API || 'http://localhost:8000'

export default axios